module.exports = __webpack_public_path__ + "static/media/girl.95ee541d.jpeg";